export default "__VITE_ASSET__D0ITMU6E__"